'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _ = require('../../');

var _DefaultString = require('../../../helpers/DefaultString');

var _Popup = require('../../../helpers/Popup');

var _Product = require('../../../helpers/Product');

var _Router = require('../../../helpers/Router');

var _popup = require('../../../redux/modules/popup');

var _InvalidCredentials = require('./InvalidCredentials.scss');

var _InvalidCredentials2 = _interopRequireDefault(_InvalidCredentials);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InvalidCredentials = (_dec = (0, _reactRedux.connect)(function (state) {
  return { auth: state.auth, type: state.popup.type };
}, { closePopup: _popup.closePopup, pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(InvalidCredentials, _Component);

  function InvalidCredentials() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, InvalidCredentials);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = InvalidCredentials.__proto__ || (0, _getPrototypeOf2.default)(InvalidCredentials)).call.apply(_ref, [this].concat(args))), _this), _this.getButtonsByProduct = function () {
      var product = _this.props.auth.productName;
      var realm = _this.props.auth.realm;
      var buttonTheme = _Popup.Popup.buttonTheme(product);
      var elements = void 0;
      switch (true) {
        case realm === _Product.REALM_NAMES.Business && product === _Product.PRODUCT_NAMES.Music:
          elements = _react2.default.createElement(
            'div',
            { className: _InvalidCredentials2.default.okButtonBusinessContent },
            _react2.default.createElement(
              'div',
              { className: _InvalidCredentials2.default.okButtonBusiness, onClick: _this.closePopup },
              _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.Ok)
            )
          );
          break;
        case realm === _Product.REALM_NAMES.Stingray && product === _Product.PRODUCT_NAMES.Music:
          elements = _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: _InvalidCredentials2.default.okButton },
              _react2.default.createElement(_.BaseButton, { onClick: _this.closePopup, buttonString: _DefaultString.translations.Retry })
            ),
            _react2.default.createElement(
              'div',
              { className: _InvalidCredentials2.default.okButton },
              _react2.default.createElement(_.BaseButton, { onClick: _this.navigateToHome, buttonString: _DefaultString.translations.SignUp })
            )
          );
          break;
        default:
          elements = _react2.default.createElement(_.BaseButton, { onClick: _this.closePopup, buttonString: _DefaultString.translations.Ok, className: _InvalidCredentials2.default.okButton, theme: buttonTheme });
      }

      return elements;
    }, _this.closePopup = function () {
      _this.props.closePopup();
    }, _this.navigateToHome = function () {
      _this.closePopup();
      _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(InvalidCredentials, [{
    key: 'render',
    value: function render() {
      var product = this.props.auth.productName;
      var realm = this.props.auth.realm;
      var isMusic = realm === _Product.REALM_NAMES.Stingray && product === _Product.PRODUCT_NAMES.Music;
      var message = isMusic ? _DefaultString.translations.ErrorInvalidCredentialsMessageMusic : _DefaultString.translations.ErrorInvalidCredentialsMessage;
      var buttonElements = this.getButtonsByProduct();
      return _react2.default.createElement(
        'div',
        { className: _InvalidCredentials2.default.invalidCredentials },
        _react2.default.createElement(
          'div',
          { className: _InvalidCredentials2.default.title },
          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.ErrorInvalidCredentialsTitle)
        ),
        _react2.default.createElement(
          'div',
          { className: _InvalidCredentials2.default.message },
          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, message)
        ),
        buttonElements
      );
    }
  }]);
  return InvalidCredentials;
}(_react.Component), _class2.propTypes = {
  auth: _react.PropTypes.object,
  closePopup: _react.PropTypes.func,
  pushState: _react.PropTypes.func.isRequired
}, _class2.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired,
  location: _react2.default.PropTypes.object
}, _temp2)) || _class);
exports.default = InvalidCredentials;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Popup/InvalidCredentials/InvalidCredentials.js
// module id = 1974
// module chunks = 0